import { ScoreIf } from './score-if';

export class ValidScore {

  private points: number;
  private totalPoints: number;
  private weight: number;

  private sourceScore: ScoreIf;

  constructor(original: ScoreIf) {
    this.points = original.getPoints();
    this.totalPoints = original.getTotalPoints();
    this.weight = original.getWeight();
    this.sourceScore = original;
  }

  getPoints(): number {
    return this.points;
  }

  getTotalPoints(): number {
    return this.totalPoints;
  }

  getPercent(): number {
    return this.points / this.totalPoints;
  }

  getWeight(): number {
    return this.weight;
  }

  isPercentInfinity(): boolean {
    return this.totalPoints === 0;
  }

  getWeightedPointsPossible(): number {
    return this.totalPoints * this.weight;
  }

  getWeightedMissingPoints(): number {
    return (this.totalPoints - this.points) * this.weight;
  }

  getSourceScore(): ScoreIf {
    return this.sourceScore;
  }

}
